<template>
  <MailCreatePdfFormComponent />
</template>

<script>
import MailCreatePdfFormComponent from '../../../../components/mail/create/MailCreatePdfFormComponent'
import {LAYOUT_TITLE_CHANGED} from "../../../../store/modules/layout/actions";
import {MAIL_CREATED} from "../../../../events/mail";

export default {
  name: "MailCreatePdfFormPage",
  components: {
    MailCreatePdfFormComponent
  },
  methods: {
    onMailCreated(mail) {
      this.$router.push({name: 'mail-view', params: {id: mail.id}})
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('mailCreatePdfFormPage.pageTitle'))

    this.$bus.$on(MAIL_CREATED, this.onMailCreated)
  },
  beforeDestroy() {
    this.$bus.$off(MAIL_CREATED, this.onMailCreated)
  }
}
</script>

<style scoped>

</style>